import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, NavLink, Link } from 'react-router-dom';
import { accountCompletionValidators } from './accountCompletionValidators';
import accountRoutes from './accountRoutes';

const CompleteIcon = () => (
  <svg width='10px' height='10px' viewBox='0 0 10 10'>
    <g id='Page-1' stroke='none' strokeWidth={1} fill='none' fillRule='evenodd'>
      <g
        id='Account-Basic-Info'
        transform='translate(-151.000000, -85.000000)'
        fill='#2976D6'
        fillRule='nonzero'
        stroke='#2976D6'
      >
        <circle id='Oval' cx={156} cy={90} r={4} />
      </g>
    </g>
  </svg>
);

const PendingIcon = () => (
  <svg width='12px' height='12px' viewBox='0 0 12 12'>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <circle
        id='pending'
        stroke='#D69929'
        fill='#D69929'
        fillRule='nonzero'
        cx='6'
        cy='6'
        r='5'
      />
    </g>
  </svg>
);

const WarningIcon = () => (
  <svg width='10px' height='10px' viewBox='0 0 10 10'>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g
        id='Account-Basic-Info'
        transform='translate(-151.000000, -85.000000)'
        fillRule='nonzero'
        stroke='#2976D6'
      >
        <circle id='Oval' cx='156' cy='90' r='4' />
      </g>
    </g>
  </svg>
);

const ListItemButton = ({
  investorUser,
  pathname,
  nextPathName,
  currentTab,
  completedTabs,
  title,
  suitabilityRequired,
  qualificationRequired,
  handleDialogOpen,
  location,
}) => {
  const { accreditationStatus } = investorUser;
  const isSectionComplete = accountCompletionValidators[pathname](investorUser);
  const isAccreditationSection = title === 'Verification';
  let StatusIcon;

  if (
    (isSectionComplete && !isAccreditationSection) ||
    (isAccreditationSection &&
      (accreditationStatus === 'APPROVED' ||
        accreditationStatus === 'EXEMPTED'))
  ) {
    StatusIcon = CompleteIcon;
  } else if (
    isAccreditationSection &&
    accreditationStatus === 'PENDING_APPROVAL'
  ) {
    StatusIcon = PendingIcon;
  } else {
    StatusIcon = WarningIcon;
  }

  return (
    <div
      className={`account ${
        location.pathname === pathname ? 'active-link' : ''
      } ${
        nextPathName !== pathname && location.pathname !== pathname
          ? 'mobile-hide'
          : ''
      }`}
    >
      <StatusIcon />
      <NavLink
        className='breadcrumb-link w-inline-block'
        activeClassName='active-page'
        to={pathname}
        onClick={(e) => {
          console.log(pathname, currentTab, completedTabs);
          let check = pathname.replace(/\baccount\b/g, '').replace(/\//g, '');
          if (
            !(
              pathname == '/account/' + currentTab ||
              completedTabs.includes(check)
            )
          ) {
            e.preventDefault();
            handleDialogOpen(currentTab);
          }
        }}
      >
        {title}
      </NavLink>
    </div>
  );
};

const AccountListItems = (props) => {
  const accountRouteKeys = Object.keys(accountRoutes);
  const activeAccountRouteKey = accountRouteKeys.find(
    (key) => props.location.pathname === key
  );
  const activeAccountRouteKeyLocation = accountRouteKeys.indexOf(
    activeAccountRouteKey
  );
  const prevPathName = accountRouteKeys[activeAccountRouteKeyLocation - 1];
  const nextPathName = accountRouteKeys[activeAccountRouteKeyLocation + 1];
  let currentTab = 'basic-information';
  let completedTabs = [];
  const investorUser = props.investorUser;
  const {
    firstName,
    lastName,
    officePhoneNumber,
    companyName,
    country,
    address,
    selectedOptionTypes,
    intendInvestingFunds,
    suitability,
    affiliationType,
    professionalDesignation,
    averageInvestmentSize,
    minimumInvestmentSize,
    preferredAreas,
    preferredListingTypes,
    preferredSectors,
    preferredTransactionTypes,
  } = investorUser;

  if (
    firstName &&
    lastName &&
    officePhoneNumber &&
    companyName &&
    country &&
    address
  ) {
    currentTab = 'qualification';
    completedTabs.push('basic-information');
  }

  if (selectedOptionTypes && intendInvestingFunds) {
    currentTab = 'suitability';
    completedTabs.push('qualification');
  }

  if (suitability) {
    currentTab = 'affiliations';
    completedTabs.push('suitability');
  }

  if (affiliationType && professionalDesignation) {
    currentTab = 'preferences';
    completedTabs.push('affiliations');
  }

  if (
    averageInvestmentSize &&
    minimumInvestmentSize &&
    preferredAreas.length > 0 &&
    preferredListingTypes.length > 0 &&
    preferredSectors.length > 0 &&
    preferredTransactionTypes.length > 0
  ) {
    currentTab = 'verification';
    completedTabs.push('preferences');
  }

  return (
    <Fragment>
      <div className='div-block'>
        <h1 className='_1st-header'>
          {props.location.pathname === '/account'
            ? null
            : accountRoutes[props.location.pathname].navTitle}
        </h1>
        <div className='line' />
      </div>
      <div className='breadcrumb-container'>
        <div className='account w-hidden-main w-hidden-medium'>
          {prevPathName && (
            <Link className='breadcrumb-link w-inline-block' to={prevPathName}>
              Go Back
            </Link>
          )}
        </div>
        {Object.keys(accountRoutes).map((pathname) => (
          <ListItemButton
            key={pathname}
            pathname={pathname}
            currentTab={currentTab}
            completedTabs={completedTabs}
            nextPathName={nextPathName}
            title={accountRoutes[pathname].title}
            {...props}
          />
        ))}
      </div>
    </Fragment>
  );
};

AccountListItems.propTypes = {
  location: PropTypes.object.isRequired,
};

ListItemButton.propTypes = {
  investorUser: PropTypes.object.isRequired,
  pathname: PropTypes.string.isRequired,
  completedTabs: PropTypes.array.isRequired,
  nextPathName: PropTypes.string,
  location: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  suitabilityRequired: PropTypes.func.isRequired,
  qualificationRequired: PropTypes.func.isRequired,
  handleDialogOpen: PropTypes.func.isRequired,
};

ListItemButton.defaultProps = {
  nextPathName: undefined,
};

const mapStateToProps = ({ router }) => ({
  location: router.location,
});

export default connect(mapStateToProps)(withRouter(AccountListItems));



// WEBPACK FOOTER //
// ./src/components/Account/AccountListItems.js